export default {
    setIsOrder(state:any, isOrder:any) {
        state.isOrder = isOrder
    }
};
